import {Injectable} from "@angular/core";
import {UserDtoExtended} from "@esa/api";

@Injectable({
  providedIn: 'root'
})
export class AdminCheckService {
  constructor() {}

  isAdmin(currentUser: UserDtoExtended): boolean{
    return (currentUser?.role?.roleName?.toLowerCase().includes('admin'));
  }
}
